import {
  CancelDialogActions,
  ImageCancelDialogLayout,
  CancelModal,
  CancelDialogMessageLayout,
} from '@Components/shared/dialogs/CancelDialog';
import { useUpdateProviderConfig } from '@Modal/hooks/providers/useUpdateProviderConfig';

export const UpdateProviderConfigCancelModalDialog: React.FC = () => {
  const { handleCancelTakeMeBack, showCancelUpdateProviderConfigForm } = useUpdateProviderConfig();

  return (
    <>
      {showCancelUpdateProviderConfigForm && (
        <CancelModal open={showCancelUpdateProviderConfigForm}>
          <ImageCancelDialogLayout
            title="Cancel provider config?"
            actions={
              <CancelDialogActions
                onReject={() => handleCancelTakeMeBack('back')}
                onConfirm={() => handleCancelTakeMeBack('')}
              />
            }
          >
            <CancelDialogMessageLayout>
              You are about to delete all the changes you have made in provider config settings
            </CancelDialogMessageLayout>
          </ImageCancelDialogLayout>
        </CancelModal>
      )}
    </>
  );
};
